import { useSelector } from "react-redux";
import ReusableDatagrid from "../components/ReusableDatagrid";

const columnsConfig = [
  {
    field: "action",
    headerName: "Recurring Action",
    width: 360,
    type: "select",
    label: "Select Action",
    options: [
      { value: "Budget", label: "Budget" },
      { value: "Internal Docketing Call", label: "Internal Docketing Call" },
      { value: "Client Call", label: "Client Call" },
      { value: "Status Report", label: "Status Report" },
      { value: "MaxVal Prosecution Alerts", label: "MaxVal Prosecution Alerts" },
      { value: "PatBase Searches", label: "PatBase Searches" },
      { value: "Updated docket sent to client", label: "Updated docket sent to client" },
      { value: "Other", label: "Other" },
    ],
  },
  {
    field: "frequency",
    headerName: "Frequency",
    width: 180,
    conditionalRequired: (row) => !row.nextActionDate || row.nextActionDate === "",
  },
  {
    field: "nextActionDate",
    headerName: "Next Action Date",
    width: 220,
    type: "date",
    label: "Select Date",
    placeholder: "Select Date",
    conditionalRequired: (row) => !row.frequency || row.frequency === "",
    valueGetter: (params) => {
      const value = params.row.nextActionDate;
      return value ? new Date(value) : null;
    },
  },
  {
    field: "notes",
    headerName: "Notes",
    width: 180,
  },
];

export default function RecurringActions({ mode }) {
  const savedData = useSelector((state) => state.kotClient.recurringActions);
  return <ReusableDatagrid title="Recurring Actions" columnsConfig={columnsConfig} initialRows={savedData} section={"recurringActions"} mode={mode} />;
}
